export const createRoleFields = [
  {
    name: "roleName",
    label: "Role Name",
    type: "text",
    required: true,
    placeholder: "Eg. Employee",
    colSpan: {
      base: 6,
      sm: 4,
      md: 2,
    },
  },
  {
    name: "prefix",
    label: "Prefix",
    type: "text",
    required: true,
    placeholder: "Eg. EMPL",

    colSpan: {
      base: 6,
      sm: 4,
      md: 2,
    },
  },
  {
    name: "status",
    label: "Status",
    type: "select",
    colSpan: {
      base: 6,
      sm: 4,
      md: 2,
    },
    options: [
      { value: "active", label: "Active" },
      { value: "inActive", label: "InActive" },
    ],
  },

  {
    name: "roleDescription",
    label: "Role Description",
    type: "textarea",
    required: true,
    colSpan: {
      base: 6,
      sm: 6,
      md: 6,
    },
  },
];
